import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function DescriptionList() {
  const { t } = useTranslation();

  return (
    <Grid item xs={12} md={12} style={{ marginTop: '20px', marginBottom: '20px' }}>
      <Typography style={{ fontWeight: 400, fontSize: 16, marginBottom: '15px' }}>
        {t('attachChildModal_attachFileDescription')}
      </Typography>
      <ol style={{ margin: 0, paddingLeft: '20px' }}>
        <li>
          <Typography variant="body1">
            {t('attachChildModal_attachFileDescriptionFirstItem')}
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            {t('attachChildModal_attachFileDescriptionSecondItem')}
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            {t('attachChildModal_attachFileDescriptionThirdItem')}
          </Typography>
        </li>
      </ol>
    </Grid>
  );
}
